"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateOutputOffset = calculateOutputOffset;
exports.solveBW = solveBW;
exports.solveBW_CfFlexible = solveBW_CfFlexible;
exports.solveCf_BWFlexible = solveCf_BWFlexible;
exports.solveCf_RfFlexible = solveCf_RfFlexible;
exports.solveQ = solveQ;
exports.solveRf_CfFlexible = solveRf_CfFlexible;
// Solves for TIA Cf when BW is flexible
function solveCf_BWFlexible(Rf, Rin, Q, Cin, gbw) {
  var GBWrad = gbw * 2 * Math.PI;
  var undersqrt1 = 1 - 4 * Q * Q - 4 * Q * Q * Rf / Rin;
  var undersqrt2 = 4 * Q * Q * GBWrad * Rf * Cin;
  if (undersqrt1 + undersqrt2 < 0) {
    Cf = -99;
  } else {
    var sqrtterm = Math.sqrt(undersqrt1 + undersqrt2);
    var Cfdenom = 2 * Q * Q * Rf * GBWrad;
    var Cf = (1 - 2 * Q * Q - 2 * Q * Q * Rf / Rin + sqrtterm) / Cfdenom;
  }
  return Cf;
}

// Solves for BW when Cf is flexible
function solveBW_CfFlexible(Rf, Rin, Q, Cin, gbw) {
  var GBWrad = gbw * 2 * Math.PI;
  var undersqrt1 = 1 - 4 * Q * Q - 4 * Q * Q * Rf / Rin;
  var undersqrt2 = 4 * Q * Q * GBWrad * Rf * Cin;
  var sqrtterm = Math.sqrt(undersqrt1 + undersqrt2);
  var wodenom = 2 * Q * (GBWrad * Rf * Cin - Rf / Rin - 1);
  var wo = (sqrtterm - 1) * GBWrad / wodenom;
  var bw = wo / (2 * Math.PI);
  return bw;
}
function solveRf_CfFlexible(gbw, bw, cIn, rIn, Q) {
  var gbwRad = gbw * 2 * Math.PI;
  var wo = bw * 2 * Math.PI;
  var num = rIn * (-wo * gbwRad + Q * gbwRad * gbwRad + Q * wo * wo);
  var denom = Q * wo * wo * (-1 + gbwRad * rIn * cIn);
  var rf = num / denom;
  return rf;
}
function solveCf_RfFlexible(gbw, bw, cIn, rIn, Q) {
  "use strict";

  var gbwRad = gbw * 2 * Math.PI;
  var wo = bw * 2 * Math.PI;
  var num = rIn * cIn * wo * gbwRad - rIn * cIn * Q * wo * wo - Q * gbwRad;
  var denom = (-wo * gbwRad + Q * gbwRad * gbwRad + Q * wo * wo) * rIn;
  var cf = num / denom;
  return cf;
}
function solveBW(cIn, rIn, cf, rf, gbw) {
  var cTotal = cIn + cf;
  var gbwRad = gbw * 2 * Math.PI;

  //with extra pole from op amp
  var wo = Math.sqrt(gbwRad / (1 / (2 * gbwRad) + rf * cTotal));
  var BW = wo / (2 * Math.PI);
  return BW;
}
function solveQ(cIn, rIn, cf, rf, gbw, BW) {
  var wo = BW * 2 * Math.PI;
  var cTotal = cIn + cf;
  var gbwRad = gbw * 2 * Math.PI;
  var num = wo * rIn * rf * cTotal;
  var denom = rIn + rf + rIn * rf * gbwRad * cf;
  var Q = num / denom;
  return Q;
}

//calculates the offset at the output of the circuit, based on the
function calculateOutputOffset(stagesObject) {
  var vosRTO;
  var stage1 = stagesObject.stage1;
  var stage2 = stagesObject.stage2;

  //Calculate offset from stage 1
  var rPar = stage1.rin * stage1.rf / (stage1.rin + stage1.rf);
  var biasError = rPar * stage1.opAmp.iBias;
  var stage1vosRTI = biasError + stage1.opAmp.vos;
  var gain = (stage1.rf + stage1.rin) / stage1.rin;
  var stage1vosRTO = stage1vosRTI * gain;

  //two stage configuration
  var rpar = null;
  var stage2vosRTI = null;
  if (stage2 !== null && stage2 !== undefined) {
    //noninverting configuration
    if (stage2.rfilter !== undefined) {
      rpar = stage2.rf * stage2.rg / (stage2.rg + stage2.rg);
      gain = (stage2.rf + stage2.rg) / stage2.rg;
      biasError = stage2.opAmp.iBias * (rpar + stage2.rfilter);
      stage2vosRTI = biasError + stage2.opAmp.vos;
      vosRTO = (stage2vosRTI + stage1vosRTO) * gain;
    }
    //inverting configuration
    else {
      rpar = stage2.rf * stage2.rg / (stage2.rg + stage2.rg);
      var noisegain = (stage2.rf + stage2.rg) / stage2.rg;
      gain = stage2.rf / stage2.rg;
      biasError = stage2.opAmp.iBias * rpar;
      stage2vosRTI = biasError + stage2.opAmp.vos;
      vosRTO = stage2vosRTI * noisegain + stage1vosRTO * gain;
    }
  }
  //one stage configuration
  else {
    vosRTO = stage1vosRTO;
  }
  return vosRTO;
}

// NOT Used
// function solveBWTheHardWay(cIn, rIn, cf, rf, gbw, rout, rsh, cd) {
//     var poleNumerator = (-rf * rout * cf) - (rf * rsh * cd) - (rf * rsh * cf) - (rout * rsh * cd);
//     var poleNumeratorSquared = ((Math.pow(rf, 2)) * (Math.pow(rout, 2)) * (Math.pow(cf, 2)))
//         - (2 * Math.pow(rf, 2) * rout * rsh * cd * cf)
//         + (2 * Math.pow(rf, 2) * rout * rsh * Math.pow(cf, 2))
//         + (Math.pow(rf, 2) * Math.pow(rsh, 2) * Math.pow(cd, 2))
//         + (2 * Math.pow(rf, 2) * Math.pow(rsh, 2) * cd * cf)
//         + (Math.pow(rf, 2) * Math.pow(rsh, 2) * Math.pow(cf, 2))
//         - (2 * rf * Math.pow(rout, 2) * rsh * cd * cf)
//         + (2 * rf * rout * Math.pow(rsh, 2) * Math.pow(cd, 2))
//         - (2 * rf * rout * Math.pow(rsh, 2) * cd * cf)
//         + (Math.pow(rout, 2) * Math.pow(rsh, 2) * Math.pow(cd, 2));
//     var poleDenominator = rf * rout * rsh * cd * cf;
//     var pole1 = -(poleNumerator + Math.sqrt(poleNumeratorSquared)) / (2 * poleDenominator);
//     var pole2 = (-poleNumerator + Math.sqrt(poleNumeratorSquared)) / (2 * poleDenominator);

//     var pole = Math.min(pole1, pole2);

//     var gbwRad = gbw * 2 * Math.PI;
//     var wo = Math.sqrt(gbwRad / (1 / (2 * gbwRad) + (1 / pole)));
//     var BW = wo / (2 * Math.PI);

//     // compare to easy way
//     //var BWeasy = this.solveBW(cIn, rIn, cf, rf, gbw);

//     return BW;
// }